export default {
  headText: " Spezialisten für Ihre Genesung",
  headSubtext:
    "In wenigen Sekunden hat ein Unfall Ihr Leben verändert. Was Sie nun brauchen, ist eine schnelle und bestmögliche Versorgung durch Spezialisten. Damit Sie in Zukunft wieder im optimalen Umfang am Leben teilhaben können – familiär, gesellschaftlich und beruflich.",
};
